module.exports = __webpack_public_path__ + "img/ferry_EN.f6a08bbc.png";